import { Confirmation, RouterContext } from '../../libs/gs-component-right-rail';
import React, { useContext } from 'react';

import styles from './visibilityOffConfirmation.scss';

export const VisibilityOnConfirmation = () => {
  const { goBack } = useContext(RouterContext);
  const SecondaryText = (
    <span className={styles.infoContainer}>
      <span>
        We’ll make these changes ASAP, but it could take up to 30 days for your site to appear in search engine results.
      </span>
      <span className={styles.changesText}>Changes take up to 30 days</span>
    </span>
  );

  return (
    <Confirmation onPrimaryAction={goBack} primaryText="Back To Settings" question="Got It!" info={SecondaryText} />
  );
};
